module.exports = __webpack_public_path__ + "static/media/good-1.adab5a9d.svg";